module.exports = __webpack_public_path__ + "static/veneer-086438ac67feebfc3be69ca854875d77.jpg";